<div
    *ngIf="player$ |async as player"
    class="tab-box-wrapper"
    [ngClass]="{
        'folded': player.isFolded,
        omaha: player.hand.length == 4,
        omaha5: player.hand.length == 5,
        'in-app-game-box': inAppGameBox
    }"
>
    <playing-card
        *ngFor="let hand of player.hand"
        [cardId]="hand"
        [toggledCard]="false"
        [isRevealed]="false"
    ></playing-card>
</div>
<player-clock
    *ngIf="clientID"
    [gameStateId]="gameStateId"
    [id]="clientID"
    [tableID]="tableID"
    [timePerTurn]="timePerTurn"
    [isLinear]="true"
></player-clock>
